export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cilChartPie',
        moduleCode: 'DASHBOARD' // Fixed: was moduleName
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Stock To Buy',
        to: '/admins/ConfirmBuyList',
        icon: 'cilCreditCard',
        moduleCode: 'STOCK_TO_BUY' // Fixed: was moduleName: 'Stocks'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Stock',
        to: '/admins/StockList',
        icon: 'cilTask',
        moduleCode: 'STOCKS'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Customer',
        to: '/admins/CustomerList',
        icon: 'cilUser',
        moduleCode: 'CUSTOMER' // Fixed: was moduleName: 'Customer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Pricelist',
        to: '/agents/VehicleList',
        icon: 'cilLocationPin',
        moduleCode: 'VEHICLE' // Fixed: was moduleName: 'Vehicle'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Advertisement',
        to: '/marketing/AdvertisementList',
        icon: 'cilSpeech',
        moduleCode: 'ADVERTISEMENT' // Fixed: was moduleName: 'Advertisement'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'MasterData',
        route: '/parameters',
        icon: 'cilFolder',
        moduleCode: 'MASTER_DATA', // Fixed: was moduleName: 'MasterData'
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Suppliers',
            to: '/admins/SupplierList',
            icon: 'cilBasket',
            subModuleCode: 'SUPPLIERS' // Fixed: was subModuleName: 'Suppliers'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Forwarder',
            to: '/admins/ForwarderList',
            icon: 'cilChevronRight',
            subModuleCode: 'FORWARDERS' // Fixed: was subModuleName: 'Forwarder'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Banks',
            to: '/admins/BankList',
            icon: 'cilDollar',
            subModuleCode: 'BANKS' // Fixed: was subModuleName: 'Banks'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Brands',
            to: '/admins/BrandList',
            icon: 'cilNotes',
            subModuleCode: 'BRANDS' // Fixed: was subModuleName: 'Brands'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Sub Companies',
            to: '/admins/SubCompanyList',
            icon: 'cilListNumbered',
            subModuleCode: 'SUB_COMPANIES' // Fixed: was subModuleName: 'SubCompanies'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'Showroom',
            to: '/admins/ShowroomList',
            icon: 'cilHome',
            subModuleCode: 'SHOWROOMS'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Reports',
        route: '/disburstment',
        icon: 'cilSpreadsheet',
        moduleCode: 'REPORT', // Fixed: was moduleName: 'Reports'
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: 'Sales Report',
            to: '/admins/salesReportList',
            icon: 'cil-spreadsheet',
            subModuleCode: 'SALES_REPORT'
          },
          {
            _name: 'CSidebarNavItem',
            name: 'LJ Reports',
            to: '/admins/LjReportList',
            icon: 'cil-file',
            subModuleCode: 'LJ_REPORTS'
          }
        ]
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Administration'],
        moduleCode: 'ADMINISTRATION', // Fixed: was moduleName: 'Administration'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Roles',
        to: '/admins/RoleList',
        icon: 'cilShieldAlt',
        subModuleCode: 'ROLES' // Fixed: was subModuleName: 'Roles'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'User',
        to: '/admins/UserList',
        icon: 'cilPeople',
        subModuleCode: 'USER' // Fixed: was subModuleName: 'User'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Audit Logs',
        to: '/admins/AuditLogList',
        icon: 'cilList',
        subModuleCode: 'AUDIT_LOGS'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Company',
        to: '/admins/Company',
        icon: 'cilGlobeAlt',
        moduleCode: 'ADMINISTRATION',
        subModuleCode: 'COMPANY'
      },
    ]
  }
];
